import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import { CROSSTAB_VIEWER_GRID_TYPE } from '../../../util/CrosstabUtils';

const cloneOrRender = (Component, props) => {
  if (!Component) {
    return null;
  }

  if (React.isValidElement(Component)) {
    return React.cloneElement(Component, props);
  }

  return <Component {...props} />;
};

const defaultCellRenderer = () => <td />;

const defaultRowRenderer = cells => <tr key={uuid()}>{cells}</tr>;

export default class CrosstabViewerGridBodyRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      windowSize: window.innerWidth,
    };
  }

  UNSAFE_componentWillMount() {
    this.updateDimensions();
  }
  componentDidMount() {
    if (window.addEventListener) {
      window.addEventListener('resize', this.updateDimensions, false);
    } else {
      window.attachEvent('resize', this.updateDimensions, false);
    }
    document
      .getElementsByClassName('sidebar-left')[1]
      .addEventListener('click', () => {
        const privateEyeWidth =
          document.getElementById('crosstabViewerGrid-container') &&
          document.getElementById('crosstabViewerGrid-container').clientWidth;
        //   let intervalNo = 0;
        //   const id = setInterval(() => {
        //     if (privateEyeWidth) {
        //       this.setState({ windowSize: this.state.windowSize + 1 });
        //     }
        //     intervalNo += 1;
        //     if (intervalNo === 10) {
        //       intervalNo = 0;
        //       clearInterval(id);
        //     }
        //   }, 100);
        setTimeout(() => {
          if (privateEyeWidth) {
            this.setState({
              windowSize:
                this.state.windowSize >= window.innerWidth
                  ? this.state.windowSize - 1
                  : this.state.windowSize + 1,
            });
          }
        }, 1100);
      });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }
  updateDimensions = () => {
    if (window.innerWidth !== this.state.windowSize) {
      setTimeout(() => {
        this.setState({ windowSize: window.innerWidth });
      }, 60);
    }
  };
  renderCells() {
    const {
      columnDefinitions,
      renderBodyCell,
      rowData,
      rowsPerStudy,
      cellElementList,
      viewerGridType,
      selectedDropdownColumn,
      filterType,
      highlightAndFilter,
      horizontalPageNo,
      horizontalEPP,
    } = this.props;

    let cells = [];

    if (viewerGridType === CROSSTAB_VIEWER_GRID_TYPE.PRIVATE_EYE) {
      const defaultVisibleCellElement = cellElementList.filter(
        ({ isVisible }) => isVisible,
      );
      const renderedColumnsLength = Math.ceil(
        horizontalEPP / defaultVisibleCellElement.length,
      );
      const lastRenderedColumn =
        horizontalPageNo + renderedColumnsLength < columnDefinitions.length
          ? horizontalPageNo + renderedColumnsLength
          : columnDefinitions.length;
      cells = columnDefinitions
        .slice(horizontalPageNo, lastRenderedColumn)
        .reduce((computedCells, columnDef, columnIndex) => {
          const cellWidths = $.map(
            $('.crosstabViewerGrid-head tr:last-child th'),
            ele => ele.getBoundingClientRect().width,
          );
          const cellsPerColumn = defaultVisibleCellElement.map(
            (cellElement, cellIndex) => {
              const computedColumnIndex = horizontalPageNo + columnIndex;
              if (renderBodyCell) {
                return renderBodyCell({
                  cellData: cellElement.isVisible
                    ? rowData.cellList[computedColumnIndex][cellElement.key]
                    : '',
                  privateEyeCellElement: cellElement,
                  cellDataList: cellElement.isVisible
                    ? rowData.cellList[computedColumnIndex]
                    : {},
                  cellElementList,
                  viewerGridType,
                  filterType,
                  hnf: highlightAndFilter,
                  cellWidth:
                    cellWidths[
                      (columnIndex * defaultVisibleCellElement.length) + cellIndex
                    ],
                  isColumnEnd:
                    cellIndex === defaultVisibleCellElement.length - 1,
                });
              }
              return defaultCellRenderer();
            },
          );
          return [...computedCells, ...cellsPerColumn];
        }, []);
    } else if (viewerGridType === CROSSTAB_VIEWER_GRID_TYPE.TREND) {
      // const defaultVisibleCellElement = cellElementList.filter(({ isVisible }) => isVisible);
      const cellWidths = $.map(
        $('.crosstabViewerGrid-head tr:last-child th'),
        ele => ele.getBoundingClientRect().width,
      );
      cells = rowsPerStudy.map((rowPerStudy, cellIndex) => {
        if (renderBodyCell) {
          return renderBodyCell({
            cellData: rowPerStudy.cellList[selectedDropdownColumn],
            viewerGridType,
            cellElementList,
            cellWidth: Math.round(cellWidths[cellIndex] * 100) / 100,
          });
        }
        return defaultCellRenderer();
      });
    } else {
      cells = columnDefinitions.map((def, i) => {
        if (def.hidden === true) {
          return null;
        }

        if (def.Cell) {
          const Cell = def.Cell;
          return cloneOrRender(Cell, {
            data: rowData,
            definition: def,
          });
        }

        const cellWidths = $.map(
          $('.crosstabViewerGrid-head tr th'),
          ele => ele.getBoundingClientRect().width,
        );

        return renderBodyCell
          ? renderBodyCell({
            cellData: rowData.cellList[i],
            hnf: highlightAndFilter,
            cellElementList,
            viewerGridType,
            filterType,
            cellWidth: Math.round(cellWidths[i] * 100) / 100,
          })
          : defaultCellRenderer();
      });
    }

    return cells;
  }

  render() {
    const { renderBodyRow, rowData } = this.props;

    const cells = this.renderCells();

    if (renderBodyRow) {
      return renderBodyRow(defaultRowRenderer, rowData, cells);
    }

    return defaultRowRenderer(cells);
  }
}

CrosstabViewerGridBodyRow.propTypes = {
  cellElementList: PropTypes.arrayOf(PropTypes.shape()),
  columnDefinitions: PropTypes.arrayOf(PropTypes.shape()),
  renderBodyCell: PropTypes.func,
  renderBodyRow: PropTypes.func,
  rowData: PropTypes.shape(),
  rowsPerStudy: PropTypes.arrayOf(PropTypes.shape()),
  viewerGridType: PropTypes.oneOf(Object.values(CROSSTAB_VIEWER_GRID_TYPE)),
  selectedDropdownColumn: PropTypes.number,
  filterType: PropTypes.string,
  highlightAndFilter: PropTypes.shape({}),
  horizontalPageNo: PropTypes.number,
  horizontalEPP: PropTypes.number,
};
